var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$validateText(_vm.tooltipText))?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.tooltipText,
        trigger: 'manual',
        show: _vm.show
    }),expression:"{\n        content: tooltipText,\n        trigger: 'manual',\n        show: show\n    }"}],staticClass:"tooltip-wrapper",on:{"mouseenter":function($event){return _vm.onEnter()},"click":function($event){return _vm.toggle()},"mouseleave":function($event){return _vm.onLeave()}}},[_vm._t("default",function(){return [_c('i',{staticClass:"fa-regular fa-info-circle icon"})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }